// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components-uganda/calculator-uganda-personal-loan/calculator-uganda-personal-loan.component.scss
// module id = 171
// module chunks = 0